module.exports = __webpack_public_path__ + "static/media/bg1.e783d473.jpg";